import React from 'react';

const CheckMark = () => (
  <svg
  className="checkmark-icon"
    viewBox="0 0 10 9"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path stroke="currentColor" d="M1 4.21879L3.4061 7L8.65587 1" strokeWidth="2" />
  </svg>
);

export default CheckMark;
